import { getCustomerApiClient } from 'api/CustomerApiClient'
import { getDummyApi, isInDummyMode } from 'dummy/static'
import CommonUtils from 'utils/CommonUtils'

const bootstrap = async () => {
  if (window.bootstrapped) return

  const portalConfig = await getCustomerApiClient()
    .getPortalConfigByDomain(CommonUtils.getEcpDomain())
    .then((res) => res.data)

  const isDummy = isInDummyMode(portalConfig)

  if (isDummy) {
    const Dummy = await getDummyApi()

    await Dummy.getConfig(portalConfig)
  }

  window.bootstrapped = true

  // Respect no search engine indexing
  if (portalConfig.prevent_search_engine_indexing) {
    let metaRobots = document.head.querySelector('meta[name="robots"]')

    if (!metaRobots) {
      metaRobots = document.createElement('meta')
      metaRobots.setAttribute('name', 'robots')
      document.head.appendChild(metaRobots)
    }

    metaRobots.setAttribute('content', 'noindex, nofollow')
  }

  import('index')
}

export default bootstrap
